export enum AppConfigValuesEnum {
  /* eslint-disable no-unused-vars */
  TENANT_BACKGROUND_LARGE = 'tenantBackgroundLarge',
  TENANT_BACKGROUND_SMALL = 'tenantBackgroundSmall',
  TENANT_LOGO = 'tenantLogo',
  TENANT_SUBDOMAIN = 'tenantSubdomain',
  TENANT_WEBSITE = 'tenantWebsite',
  TENANT_ADDRESS = 'tenantAddress',
  TENANT_THERAPY_TYPE = 'tenantTherapyType',
  TENANT_CONTACT = 'tenantContact',
  TENANT_EMAIL = 'tenantEmail',
  TENANT_ID = 'tenantId',
  TENANT_NAME = 'tenantName',
  TENANT_CONTACT_FORM = 'tenantContactForm',
  BUG_EMAIL = 'bugEmail',
  EHR_NAME = 'ehrName',
  POWERED_BY_I2I_LOGO = 'poweredByI2ILogo',
  TENANT_BACKGROUND_COLOR = 'tenantBackgroundColor',
  IS_CALENDAR_ENABLED = 'isCalendarEnable',
  BLACKOUT_DAYS = 'blackoutDays',
  BLACKOUT_HOURS = 'blackoutHours',
  PRACTICE_TIME_ZONE = 'practiceTimeZone',
  PRACTICE_TIME_ZONE_KEY = 'practiceTimeZoneKey',
  TELETHERAPY_ENABLED = 'teletherapyEnabled',
  GOOGLE_ADS_TRACKING_ID = 'googleAdsTrackingId',
  META_ADS_TRACKING_ID = 'metaAdsTrackingId',
  TIKTOK_ADS_TRACKING_ID = 'tiktokAdsTrackingId',
  SNAPCHAT_ADS_TRACKING_ID = 'snapchatAdsTrackingId',
  NEED_HELP_SELF_MATCH_CONTACT_NUMBER = 'needHelpSelfMatchContactNumber',
  THERAPIST_PRE_ONBOARDING_ENABLED = 'therapistPreOnboardingEnabled',
  BILLING_DASHBOARD_ENABLED = 'billingDashboardEnabled',
  IS_DIRECTORY_PLATFORM = 'isDirectoryPlatform',
  CLINICIAN_SORTING_CONFIGURATION = 'clinicianSortingConfiguration',
  EHR_CODE_LENGTH = 'ehrCodeLength',
}
